// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ChatInterface.css */
.chat-container {
    display: flex;
    height: 85vh;
    /* min-width: 600px; */
    background-color: #f3f3f3;
    font-family: 'Poppins', sans-serif;
    margin-right: 2px;
}

/* Sidebar Styles */
.sidebar {
    width: 300px;
    background-color: white;
    border-right: 8px solid #f5f2e7;
    display: flex;
    flex-direction: column;
}


.sidebar-search {
    padding: 12px;
    /* border-bottom: 1px solid #ddd; */
    position: relative;
}

.sidebar-search input {
    width: 100%;
    /* height: 10px; */
    padding: 10px 35px;
    border-radius: 7px;
    border: 1px solid #ddd;
    outline: none;
    border: 2px solid #ddd !important;
}

.sidebar-search i {
    position: absolute;
    left: 25px;
    top: 50%;
    transform: translateY(-50%);
    color: #888;
    font-size: 15px;
}

.sidebar-users {
    flex: 1 1;
    overflow-y: auto;
}

.sidebar-user-item {
    display: flex;
    align-items: center;
    padding: 12px;
    border-bottom: 1px solid #f0f0f0;
    cursor: pointer;
    transition: background 0.3s;
}

.sidebar-user-item:hover {
    background: #f9f9f9;
}

.sidebar-user-avatar img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
}

.sidebar-user-info {
    flex: 1 1;
    margin-left: 10px;
    display: flex;
}

.sidebar-user-info h3 {
    font-size: 14px;
    color: #6B8E76;
    margin: 0;
}

.sidebar-user-info p {
    font-size: 12px;
    color: #888;
    margin: 2px 0 0;
}

.sidebar-user-time {
    font-size: 12px;
    color: #888;
    margin-left:auto ;
}

/* Main Chat Area */
.main-chat-area {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    background: white;
}

.chat-header {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #ddd;
    background: white;
}

.chat-header-avatar img {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    object-fit: cover;
}

.chat-header-info {
    margin-left: 12px;
}

.chat-header-info h2 {
    font-size: 16px;
    margin: 0;
    color: #333;
}

.chat-header-info p {
    font-size: 12px;
    color: #888;
    margin: 0;
}

/* Messages Area */
.chat-messages {
    flex: 1 1;
    padding: 16px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

/* Individual Message */
.chat-message {
    max-width: 70%;
    width:fit-content;
    padding: 10px 14px;
    border-radius: 10px;
    font-size: 14px;
    line-height: 1.4;
    position: relative;
    display: flex;
    align-items: flex-end;
    margin-left: 10px;
    margin-bottom: 6px;
}

/* Sender's Message */
.chat-message-user {
    background-color: #6b4750;
    color: white;
    align-self: flex-end;
    border-bottom-right-radius: 0;
    margin-left: auto;
    text-align: right;
    width:fit-content;
}

/* Receiver's Message */
.chat-message-other {
    background-color: #f5f5f5;
    color: black;
    align-self: flex-start;
    border-bottom-left-radius: 0;
    margin-right: auto;
    text-align: left;
    display: flex;
    align-items: center;
    width:fit-content;
}
/* Receiver's Profile Picture */
.chat-message-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    margin-top: 3px;
    /* margin-right: 8px; */
    /* background-color:transparent; */
}

/* .chat-message-timestamp {
    font-size: 12px;
    color: gray;
    margin-top: 4px;
    text-align: left;
  } */
.chat-message-timestamp-user{
    font-size: 10px;
    color: gray;
    /* margin-top: 2px; */
    text-align: left;
    margin-left: auto;
}
.chat-message-timestamp-other{
    font-size: 10px;
    color: gray;
    /* margin-top: 4px; */
    text-align: left;
    margin-left: 38px;
}

/* Chat Footer (Input Area) */
.chat-footer {
    padding: 12px 16px;
    /* border-top: 1px solid #ddd; */
    background: white;
}

.chat-footer .input-container {
    display: flex;
    align-items: center;
    background: #f9f9f9;
    border-radius: 80px;
    padding: 8px;
    border: 1px solid #ddd;
}

.chat-footer input {
    flex: 1 1;
    border: none;
    outline: none;
    padding: 8px;
    background: transparent;
    border: none !important;
}

.chat-footer .send-icon {
    cursor: pointer;
    width: 24px;
    height: 24px;
    object-fit: contain;
}

.chat-all-messages{  
    display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/InsocialOrbit/Brand/Message/Message.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA,mBAAmB;AACnB;IACI,YAAY;IACZ,uBAAuB;IACvB,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;AAC1B;;;AAGA;IACI,aAAa;IACb,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,gCAAgC;IAChC,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA,mBAAmB;AACnB;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,SAAS;AACb;;AAEA,kBAAkB;AAClB;IACI,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,uBAAuB;AACvB;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,qBAAqB;AACrB;IACI,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,6BAA6B;IAC7B,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA,uBAAuB;AACvB;IACI,yBAAyB;IACzB,YAAY;IACZ,sBAAsB;IACtB,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;AACA,+BAA+B;AAC/B;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA;;;;;KAKK;AACL;IACI,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB","sourcesContent":["/* ChatInterface.css */\n.chat-container {\n    display: flex;\n    height: 85vh;\n    /* min-width: 600px; */\n    background-color: #f3f3f3;\n    font-family: 'Poppins', sans-serif;\n    margin-right: 2px;\n}\n\n/* Sidebar Styles */\n.sidebar {\n    width: 300px;\n    background-color: white;\n    border-right: 8px solid #f5f2e7;\n    display: flex;\n    flex-direction: column;\n}\n\n\n.sidebar-search {\n    padding: 12px;\n    /* border-bottom: 1px solid #ddd; */\n    position: relative;\n}\n\n.sidebar-search input {\n    width: 100%;\n    /* height: 10px; */\n    padding: 10px 35px;\n    border-radius: 7px;\n    border: 1px solid #ddd;\n    outline: none;\n    border: 2px solid #ddd !important;\n}\n\n.sidebar-search i {\n    position: absolute;\n    left: 25px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #888;\n    font-size: 15px;\n}\n\n.sidebar-users {\n    flex: 1;\n    overflow-y: auto;\n}\n\n.sidebar-user-item {\n    display: flex;\n    align-items: center;\n    padding: 12px;\n    border-bottom: 1px solid #f0f0f0;\n    cursor: pointer;\n    transition: background 0.3s;\n}\n\n.sidebar-user-item:hover {\n    background: #f9f9f9;\n}\n\n.sidebar-user-avatar img {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.sidebar-user-info {\n    flex: 1;\n    margin-left: 10px;\n    display: flex;\n}\n\n.sidebar-user-info h3 {\n    font-size: 14px;\n    color: #6B8E76;\n    margin: 0;\n}\n\n.sidebar-user-info p {\n    font-size: 12px;\n    color: #888;\n    margin: 2px 0 0;\n}\n\n.sidebar-user-time {\n    font-size: 12px;\n    color: #888;\n    margin-left:auto ;\n}\n\n/* Main Chat Area */\n.main-chat-area {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    background: white;\n}\n\n.chat-header {\n    display: flex;\n    align-items: center;\n    padding: 12px 16px;\n    border-bottom: 1px solid #ddd;\n    background: white;\n}\n\n.chat-header-avatar img {\n    width: 45px;\n    height: 45px;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.chat-header-info {\n    margin-left: 12px;\n}\n\n.chat-header-info h2 {\n    font-size: 16px;\n    margin: 0;\n    color: #333;\n}\n\n.chat-header-info p {\n    font-size: 12px;\n    color: #888;\n    margin: 0;\n}\n\n/* Messages Area */\n.chat-messages {\n    flex: 1;\n    padding: 16px;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n/* Individual Message */\n.chat-message {\n    max-width: 70%;\n    width:fit-content;\n    padding: 10px 14px;\n    border-radius: 10px;\n    font-size: 14px;\n    line-height: 1.4;\n    position: relative;\n    display: flex;\n    align-items: flex-end;\n    margin-left: 10px;\n    margin-bottom: 6px;\n}\n\n/* Sender's Message */\n.chat-message-user {\n    background-color: #6b4750;\n    color: white;\n    align-self: flex-end;\n    border-bottom-right-radius: 0;\n    margin-left: auto;\n    text-align: right;\n    width:fit-content;\n}\n\n/* Receiver's Message */\n.chat-message-other {\n    background-color: #f5f5f5;\n    color: black;\n    align-self: flex-start;\n    border-bottom-left-radius: 0;\n    margin-right: auto;\n    text-align: left;\n    display: flex;\n    align-items: center;\n    width:fit-content;\n}\n/* Receiver's Profile Picture */\n.chat-message-avatar {\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    margin-top: 3px;\n    /* margin-right: 8px; */\n    /* background-color:transparent; */\n}\n\n/* .chat-message-timestamp {\n    font-size: 12px;\n    color: gray;\n    margin-top: 4px;\n    text-align: left;\n  } */\n.chat-message-timestamp-user{\n    font-size: 10px;\n    color: gray;\n    /* margin-top: 2px; */\n    text-align: left;\n    margin-left: auto;\n}\n.chat-message-timestamp-other{\n    font-size: 10px;\n    color: gray;\n    /* margin-top: 4px; */\n    text-align: left;\n    margin-left: 38px;\n}\n\n/* Chat Footer (Input Area) */\n.chat-footer {\n    padding: 12px 16px;\n    /* border-top: 1px solid #ddd; */\n    background: white;\n}\n\n.chat-footer .input-container {\n    display: flex;\n    align-items: center;\n    background: #f9f9f9;\n    border-radius: 80px;\n    padding: 8px;\n    border: 1px solid #ddd;\n}\n\n.chat-footer input {\n    flex: 1;\n    border: none;\n    outline: none;\n    padding: 8px;\n    background: transparent;\n    border: none !important;\n}\n\n.chat-footer .send-icon {\n    cursor: pointer;\n    width: 24px;\n    height: 24px;\n    object-fit: contain;\n}\n\n.chat-all-messages{  \n    display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
